import React from 'react';
import { Card } from '../ui/Card';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-cream" data-id="element-60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-62">
          {/* Who it is for */}
          <Card variant="elevated" className="p-8 md:p-10 border-t-4 border-t-olive" data-id="element-63">
            <h3 className="font-heading text-2xl font-bold mb-8 text-taupe flex items-center gap-3" data-id="element-64">
              <span className="bg-olive/20 text-olive p-2 rounded-full" data-id="element-65">
                <CheckIcon className="w-6 h-6" data-id="element-66" />
              </span>
              Este método ES para ti si:
            </h3>
            <ul className="space-y-6 font-body text-taupe-light" data-id="element-67">
              <li className="flex items-start gap-4" data-id="element-68">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-69"></div>
                <p data-id="element-70">
                  Eres mujer de <strong data-id="element-71">más de 45-50 años</strong> y sientes tu
                  metabolismo "dormido".
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-72">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-73"></div>
                <p data-id="element-74">
                  Sufres de <strong data-id="element-75">inflamación abdominal persistente</strong>{' '}
                  (la famosa "panza de cortisol").
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-76">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-77"></div>
                <p data-id="element-78">
                  Duermes mal y <strong data-id="element-79">te despiertas cansada</strong>, sin
                  importar cuánto descansen.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-80">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-81"></div>
                <p data-id="element-82">
                  Buscas un método natural basado en{' '}
                  <strong data-id="element-83">ciencia hormonal</strong>, no en restricciones
                  extremas.
                </p>
              </li>
            </ul>
          </Card>

          {/* Who it is NOT for */}
          <Card variant="elevated" className="p-8 md:p-10 border-t-4 border-t-rose" data-id="element-84">
            <h3 className="font-heading text-2xl font-bold mb-8 text-taupe flex items-center gap-3" data-id="element-85">
              <span className="bg-rose/20 text-rose p-2 rounded-full" data-id="element-86">
                <XIcon className="w-6 h-6" data-id="element-87" />
              </span>
              Este método NO es para ti si:
            </h3>
            <ul className="space-y-6 font-body text-taupe-light" data-id="element-88">
              <li className="flex items-start gap-4" data-id="element-89">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-90"></div>
                <p data-id="element-91">
                  Buscas una <strong data-id="element-92">"pastilla mágica"</strong> para bajar de
                  peso en 24 horas.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-93">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-94"></div>
                <p data-id="element-95">
                  Prefieres <strong data-id="element-96">dietas de hambre extrema</strong> en lugar
                  de nutrición inteligente.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-97">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-98"></div>
                <p data-id="element-99">
                  No estás dispuesta a dedicar <strong data-id="element-100">10 minutos</strong> a una
                  rutina de relajación nocturna.
                </p>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </section>;
}